import { ServiceTypeApiResponse } from 'src/types/service-type';

import axiosInstance from './instance';

const serviceTypeApi = {
  /**
   * 서비스 타입 조회 API
   * GET /{service-code}/guest/service-type
   *
   * @param serviceCode - 서비스 코드 (예: 'anchor', 'brk' 등)
   * @returns Promise<ServiceTypeApiResponse>
   */
  getServiceType(serviceCode: string) {
    return axiosInstance.get<ServiceTypeApiResponse>(`/guest/service-type`);
  },
};

export default serviceTypeApi;
